import { useEphiCount } from '@/features/ephi/hooks/useEphiCount'
import { useEphiStore } from '@/features/ephi/store/ephi-store'
import { EphiIcon } from './icons/ephi-icon'

export function EphiCounter() {
  const ephiCount = useEphiCount()
  const { loading } = useEphiStore()

  const formatNumber = (num: number) => {
    return new Intl.NumberFormat('pt-BR').format(num)
  }

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 text-primary rounded-full min-w-[7rem] justify-center">
      <EphiIcon className="w-3.5 h-6 shrink-0" />
      <span className="text-sm font-medium tabular-nums min-w-[3rem] text-center">
        {loading ? '...' : formatNumber(ephiCount)}
      </span>
    </div>
  )
} 